// extracted by mini-css-extract-plugin
module.exports = {"primaryOutline":"antd-pro-ui-button-index-primaryOutline","linkCompact":"antd-pro-ui-button-index-linkCompact"};